import { requestJson } from './http-json';

interface PublicReferralLinkResponse {
  status: 'active' | 'expired';
  expiry_reason: 'scheduled' | 'manual' | null;
  target_path: string;
  referred_agent: string | null;
  expires_at: string | null;
}

export interface PublicReferralLink {
  status: 'active' | 'expired';
  expiryReason: 'scheduled' | 'manual' | null;
  targetPath: string;
  referredAgent: string | null;
  expiresAt: string | null;
}

export async function fetchPublicReferralLink(token: string): Promise<PublicReferralLink> {
  const payload = await requestJson<PublicReferralLinkResponse>(
    `/api/v1/referral-links/${encodeURIComponent(token)}`,
    {},
    'Resolve referral link',
  );
  return {
    status: payload.status,
    expiryReason: payload.expiry_reason,
    targetPath: payload.target_path,
    referredAgent: payload.referred_agent,
    expiresAt: payload.expires_at,
  };
}

export async function claimReferralLink(token: string): Promise<boolean> {
  const payload = await requestJson<{ claimed: boolean }>(
    `/api/v1/referral-links/${encodeURIComponent(token)}/claim`,
    { method: 'POST' },
    'Claim referral attribution',
  );
  return payload.claimed;
}
